import React from 'react'
import { Provider } from 'react-redux'
import { ThemeProvider as StyledProvider } from 'styled-components'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { PersistGate } from 'redux-persist/integration/react'
import MomentUtils from '@date-io/moment'
import defaultTheme, { materialTheme } from 'utils/theme'
import { store, persistor, history } from 'redux/store'
import { ConnectedRouter } from 'connected-react-router'
import './index.css'
import { ConfirmProvider } from 'material-ui-confirm'
import Router from './router'

export default () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <PersistGate loading={null} persistor={persistor}>
          <StyledEngineProvider injectFirst>
            <StyledProvider theme={defaultTheme}>
              <ThemeProvider theme={materialTheme}>
                <ConfirmProvider>
                  <LocalizationProvider dateAdapter={MomentUtils}>
                    <ToastContainer />
                    <Router />
                  </LocalizationProvider>
                </ConfirmProvider>
              </ThemeProvider>
            </StyledProvider>
          </StyledEngineProvider>
        </PersistGate>
      </ConnectedRouter>
    </Provider>
  )
}
